import formatDate from 'date-fns/format';
import React, {useRef} from 'react';
import {useSelector} from 'react-redux';
import {View, Text, Platform} from 'react-native';
import {images} from '../../../../../assets/icons';
import {Button} from '../../../../../shared/components/button';
import {CustomScrollView} from '../../../../../shared/components/scrollView';
import {CertificateInfo} from '../../../../../shared/models/api/eCertificatesResponsePayload';
import {LoadableContent} from '../../../../../shared/components/loadableContent';
import {useInfoTabMobileStyles} from './InfoTabMobile.style';
import {numberFormatToRub} from '../../../../../shared/utils/numberFormatToRub';
import {ScrollViewMapProps} from '../../../../../shared/components/yaMap';
import {sellersSelector} from '../../../../../redux/selectors/eCertificates';
import {SellersGeoMap} from '../../SellersGeoMap';

interface InfoTabProps {
  certificate?: CertificateInfo | null;
  mapProps: ScrollViewMapProps;
  onExportCertificate: () => void;
}

export function InfoTabMobile({certificate, mapProps, onExportCertificate}: InfoTabProps) {
  const styles = useInfoTabMobileStyles();
  const sellers = useSelector(sellersSelector());
  const mapContainerRef = useRef<View>(null);
  const {templateName, certificateNumber, statusName, actualAmount, startDate, endDate, truBalance, organizationName} =
    certificate ?? {};

  return (
    <LoadableContent loading={!certificate}>
      <View style={styles.cardInfo}>
        <View style={styles.cardRow}>
          <Text style={styles.cardTitle}>Рег. номер</Text>
          <Text style={styles.cardText}>{certificateNumber}</Text>
        </View>

        <View style={styles.cardRow}>
          <Text style={styles.cardTitle}>Наименование</Text>
          <Text style={styles.cardText}>{templateName}</Text>
        </View>

        <View style={[styles.cardRow, {flexDirection: 'row', width: '100%'}]}>
          <View style={[{flexBasis: '50%'}]}>
            <Text style={styles.cardTitle}>Дата начала</Text>
            <Text style={styles.cardText}>{startDate ? formatDate(new Date(startDate), 'dd.MM.yyyy') : '-'}</Text>
          </View>

          <View style={{flexBasis: '50%'}}>
            <Text style={styles.cardTitle}>Дата окончания</Text>
            <Text style={styles.cardText}>{endDate ? formatDate(new Date(endDate), 'dd.MM.yyyy') : '-'}</Text>
          </View>
        </View>

        <View style={[styles.cardRow, {flexDirection: 'row', width: '100%'}]}>
          <View style={{flexBasis: '50%'}}>
            <Text style={styles.cardTitle}>Статус</Text>
            <Text style={styles.cardPrimaryText}>{statusName}</Text>
          </View>

          {certificate && certificate.certificateTypeCode !== 'ECTP0001' && (
            <View style={{flexBasis: '50%'}}>
              <Text style={styles.cardTitle}>Доступный остаток</Text>
              <Text style={styles.balance}>{numberFormatToRub(actualAmount ?? 0)}</Text>
            </View>
          )}
        </View>

        <Text style={styles.cardTitle}>Наименование организации, предоставляющей сертификат</Text>
        <Text style={styles.cardText}>{organizationName}</Text>
      </View>

      <Button
        id='download-ec'
        type='secondary'
        icon={images.Download}
        iconProps={{width: 24, height: 24, strokeWidth: Platform.OS !== 'web' ? 0.1 : undefined}}
        iconPosition='left'
        text='Выгрузить ЭС'
        style={{width: '100%', maxWidth: 400, alignSelf: 'center', marginVertical: 24}}
        onPress={onExportCertificate}
      />

      <Text style={styles.subtitle}>Товары/работы/услуги возможные к приобретению по данному сертификату</Text>

      <View style={styles.truCardList}>
        <CustomScrollView style={{maxHeight: 500, width: '100%'}} withRefresh={false}>
          {truBalance?.length ? (
            <>
              {truBalance.map(({truId, truName}) => (
                <View key={truId} style={styles.truRow}>
                  <Text style={styles.truName}>{truName}</Text>
                </View>
              ))}
            </>
          ) : null}
        </CustomScrollView>
      </View>

      <View ref={mapContainerRef}>
        <SellersGeoMap sellers={sellers} mapProps={mapProps} />
      </View>
    </LoadableContent>
  );
}
